
<c-card *transloco="let t">
  <c-card-body>

      <div class="row">
        <div class="col-12 col-md-8">

          <h1>{{ t('Welcome to the Lone Worker Safety Awards') }}</h1>

          <p>{{ t('Keeping your workers') }} <b>{{ t('safe') }}</b> {{ t('is important to us.') }} <b>{{ t('Staying safe') }}</b> {{ t('is very important to') }} <b>{{ t('your workers and your company') }}</b>! {{ t("But just because something is important, doesn’t mean it can’t be") }} <b>{{ t('fun') }}</b> {{ t('too') }}!</p>

          <p>{{ t("OK Alone's") }} <i class="fa fa-trophy gold" aria-hidden="true"></i> {{ t('Safety Awards offer an engaging way to') }} <b>{{ t('stay safe') }}</b>, {{ t('while using the lone worker system to') }} <b>{{ t('compete') }}</b> {{ t('with colleagues and companies across the world. The program recognises OK Alone feature usage or when a worker completes a safe shift and rewards them with badges, points and rankings.') }}</p>

          <p>{{ t('Who will be the') }} <b>#1 {{ t('WORKER') }}</b> {{ t('in your company, your country or the world?!') }}</p>

        </div>
        <div class="col-12 col-md-4 justify-content-end" *ngIf="months && months.length > 0">

          <!-- <div class="card">
            <div class="card-header">
              <i class="fa-solid fa-envelopes-bulk"></i> {{ t('Manage Awards Subscription') }}
            </div>
            <div class="card-body p-1">
              <div *ngIf="monitor_subscribed" class="text-center">
                <i class="fa-solid fa-circle-check text-success"></i> {{ t('Awards sent to') }} {{okService.me.email}}
                <div class="text-end">
                  <button class="btn btn-sm btn-link" role="button" (click)="toggleMonitorSubscribe(false)"><i class="fas fa-times-circle"></i> {{ t('Unsubscribe') }}</button>
                </div>
              </div>
              <div *ngIf="!monitor_subscribed" class="text-center">
                {{ t('Get awards sent to') }} {{okService.me.email}}? <br/>
                <button class="btn btn-success btn-sm text-white" role="button" (click)="toggleMonitorSubscribe(true)"><i class="fa-solid fa-circle-check"></i> {{ t('Subscribe') }}</button>
              </div>
              <hr class="m-1"/>

              <div *ngIf="award_subscribed" class="text-center">
                <i class="fa-solid fa-circle-check text-success"></i> {{ t('Awards sent to workers via email') }}
                <div class="text-end">
                  <button class="btn btn-sm btn-link" role="button" (click)="toggleWorkerSubscribe(false)"><i class="fas fa-times-circle"></i> {{ t('Unsubscribe') }}</button>
                </div>
              </div>
              <div *ngIf="!award_subscribed" class="text-center">
                {{ t('Get awards sent to workers via email?') }} <br/>
                <button class="btn btn-success btn-sm text-white" role="button" (click)="toggleWorkerSubscribe(true)"><i class="fa-solid fa-circle-check"></i> {{ t('Send to Workers') }}</button>
              </div>
            </div>
          </div> -->


          <div *ngIf="months.length > 0">
            <form [formGroup]="formGroup">
              <div class="row mb-3 mt-3">
                <label class="col-3 text-end">{{ t('Month') }} </label>
                <div class="col-sm-9">

                  <ng-select
                  class=""
                  [items]="months"
                  bindLabel="name"
                  bindValue="value"
                  formControlName="month"
                  placeholder="Change the month"
                  (change)="monthChanged()"
                  >
                  </ng-select>

                </div>
              </div>
            </form>

          </div>

        </div>
      </div>


      <div class="row">
        <div class="col">

      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link"  aria-current="page"  (click)="page='home'" [class.active]="page=='home'"><i class="fa-solid fa-house"></i> {{ t('Awards Home') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='champions'" [class.active]="page=='champions'"><i class="fa-solid fa-trophy"></i> {{ t('Safety Champions') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='certificates'" [class.active]="page=='certificates'"><i class="fa-solid fa-award"></i> {{ t('Certificates') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='reportcards'" [class.active]="page=='reportcards'"><i class="fa-solid fa-file-circle-check"></i> {{ t('Report Cards') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='workerrankings'" [class.active]="page=='workerrankings'"><i class="fa-solid fa-users"></i> {{ t('Worker Rankings') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='companyrankings'" [class.active]="page=='companyrankings'"><i class="fa-solid fa-building"></i> {{ t('Company Rankings') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='examples'" [class.active]="page=='examples'"><i class="fa-solid fa-star-half-stroke"></i> {{ t('Award Examples') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  (click)="page='faq'" [class.active]="page=='faq'"><i class="fa-solid fa-circle-question"></i> {{ t('FAQ') }}</a>
        </li>
      </ul>
    </div>
  </div>

  <br/><br/>


<app-awards-home *ngIf="page == 'home'" [month]="month"></app-awards-home>
<app-awards-certificates *ngIf="page == 'certificates'" [month]="month"></app-awards-certificates>
<app-awards-champions *ngIf="page == 'champions'" [month]="month"></app-awards-champions>
<app-awards-reportcards *ngIf="page == 'reportcards'" [month]="month"></app-awards-reportcards>
<app-awards-companyrankings *ngIf="page == 'companyrankings'" [month]="month"></app-awards-companyrankings>
<app-awards-workerrankings *ngIf="page == 'workerrankings'" [month]="month"></app-awards-workerrankings>
<app-awards-examples *ngIf="page == 'examples'" [month]="month"></app-awards-examples>
<app-awards-faq *ngIf="page == 'faq'" [month]="month"></app-awards-faq>


</c-card-body>
</c-card>
